import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { get, noop, isString } from "lodash";
import { Image } from "antd";
import WhiteSpace from "./WhiteSpace";

interface Props {
  value?: any;
  onChange?: (f: File) => void;
  accept?: string;
}

const FilePicker: React.FC<Props> = (props) => {
  const { accept, value, onChange = noop, ...rest } = props;
  const [src, setSrc] = useState<string | ArrayBuffer | null>("");

  const readerRef = useRef<FileReader | null>(null);

  useEffect(() => {
    if (isString(value)) {
      setSrc(value);
    }
  }, [value]);

  const reader = useMemo(() => {
    if (!readerRef.current) {
      readerRef.current = new FileReader();
    }
    return readerRef.current;
  }, [readerRef]);

  useEffect(() => {
    reader.onloadend = function (e) {
      setSrc(reader.result);
    };
  }, [reader, setSrc]);

  const handleInputChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const file = get(e?.target?.files, "[0]");
      onChange(file);
      reader.readAsDataURL(file);
    },
    [onChange, reader]
  );

  return (
    <>
      <input
        type="file"
        accept={accept}
        onChange={handleInputChange}
        {...rest}
      />
      <WhiteSpace size="sm" />
      {!!src && (
        <Image
          width={"100%"}
          style={{ maxHeight: 200, overflow: "hidden" }}
          src={src as any}
          alt="Preview"
        />
      )}
    </>
  );
};

export default FilePicker;
